import { TRACKING_SUBMIT, TRACKING_COMPLETE } from './../constants/constants';
import { Action, ThunkAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import {
    ICommentModal, IMoreContextModal, IUserActionRequestModel, IAuditResponseModel, IUserAccessDataModel
} from '../models/IOpportunitiesAPIModel';
import axios from '../utils/APIUtils';
import { OPPORTUNITIES_API_PATHS } from '../constants/constants';
import { getallOpportunities, setCommentStatus } from '../slices/allOpportunitySlice';
import { UserManager } from '@forge/sso-client';
import { getCommentsDetail } from '../slices/allOpportunitySlice';
import { isAks } from 'src/utils/properties/UrlsAndEnvProperties';
import axiosInstance from '../utils/APIUtils';

// Comments  Api
export const updateComments = (insightId: number, data: ICommentModal): ThunkAction<any, RootState, unknown, Action<string>> => dispatch => {
    return new Promise<void>((resolve, reject) => {
        axios.post(`${OPPORTUNITIES_API_PATHS.opportunities}/${insightId}/user-comment`, data).then(() => {
            if (data.type === 'comment') {
                dispatch(getCommentsDetail(insightId));
            } else if (data.type === TRACKING_SUBMIT || data.type === TRACKING_COMPLETE) {
                dispatch(getallOpportunities());
            }
            resolve();
        }).catch(() => reject());
    });
};

//duplicated Comments Api for multiple call issue
export const updateCommentsBox = (insightId: number, data: ICommentModal): ThunkAction<any, RootState, unknown, Action<string>> => dispatch => {
    return new Promise<void>((resolve, reject) => {
        axios.post(`${OPPORTUNITIES_API_PATHS.opportunities}/${insightId}/user-comment`, data).then(() => {
            dispatch(setCommentStatus('loading'))
            resolve();
        }).catch(() => reject());
    });
};

export const updateCommentsBoxImage = (insightId: number, userActionModel: string | Blob | File | FormData | IUserActionRequestModel, type: string, headers?: string): ThunkAction<any, RootState, unknown, Action<string>> => dispatch => {
    return new Promise<void>((resolve, reject) => {
        axiosInstance.post(`${OPPORTUNITIES_API_PATHS.opportunities}/${insightId}/upload?type=${type}`, userActionModel,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }        
        }).then(() => {
            dispatch(setCommentStatus('loading'));
            resolve();
        }).catch(() => reject());
    });
};

// GetMoreContext API
export const updateMoreContext = (insightId: number, data: IMoreContextModal, headers: string = ''): ThunkAction<any, RootState, unknown, Action<string>> => dispatch => {
    return new Promise<void>(async (resolve, reject) => {
        const userManager = UserManager.getInstance();
        const user = (await userManager.getUser());
        if (isAks() || user?.id_token) {
            axios.post(`${OPPORTUNITIES_API_PATHS.opportunities}/${insightId}/share`, data, {
                headers: {
                    'x-id-token': `Bearer ${isAks() ? sessionStorage.getItem("idToken") : (user)?.id_token}`
                }
            }).then((response: any) => {
                dispatch(getallOpportunities());
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
        }
    });
};

export const updateAuditOpportunity = (insightId: number, data: IAuditResponseModel): ThunkAction<any, RootState, unknown, Action<string>> => dispatch => {
    return new Promise<void>(async (resolve, reject) => {
        const userManager = UserManager.getInstance();
        const user = (await userManager.getUser());
        if (isAks() || user?.id_token) {
            axios.post(`${OPPORTUNITIES_API_PATHS.opportunities}/${insightId}/audit-response`, {
                'audit_response': data
            }, {
                headers: {
                    'x-id-token': `Bearer ${isAks() ? sessionStorage.getItem("idToken") : (user)?.id_token}`
                }
            }).then((response: any) => {
                //   dispatch(getallOpportunities());
                //   dispatch(getStatusPills());
                resolve(response);
            }).catch(() => reject());
        }
    });
};

// ClaimOwnership API
export const updateClaimOwnership = (insightId: number, data: string): ThunkAction<any, RootState, unknown, Action<string>> => dispatch => {
    return new Promise<void>((resolve, reject) => {
        axios.put(`${OPPORTUNITIES_API_PATHS.opportunities}/${insightId}/assign`, { 'assigne': data }).then(() => {
            dispatch(getallOpportunities());
            resolve();
        }).catch(() => reject());
    });
};

// upload document API
export const saveUserActionData = (insightId: number, userActionModel: string | Blob | File | FormData | IUserActionRequestModel, type: string, headers?: string): ThunkAction<any, RootState, unknown, Action<string>> => dispatch => {
    return new Promise<void>((resolve, reject) => {
        axiosInstance.post(`${OPPORTUNITIES_API_PATHS.opportunities}/${insightId}/upload?type=${type}`, userActionModel,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }        
        }).then((res:any) => {
            dispatch(getCommentsDetail(insightId));
            resolve(res);
        }).catch((error) => reject(error));
    });
};



export const getReviewActivityLog = (data: ICommentModal): ThunkAction<any, RootState, unknown, Action<string>> => dispatch => {
    return new Promise<void>((resolve, reject) => {
        axios.post(`${OPPORTUNITIES_API_PATHS.opportunities}/activity-log`, data).then((response) => {
            resolve(response.data);
        }).catch(() => reject());
    });
};

export const getTrackingStatus = (insightId: number): ThunkAction<any, RootState, unknown, Action<string>> => dispatch => {
    return new Promise<void>((resolve, reject) => {
        axios.get(`${OPPORTUNITIES_API_PATHS.opportunities}/${insightId}/tracking-ids`).then((response) => {
            resolve(response.data);
        }).catch(() => reject());
    });
};

//Action Tracking API
export const getActionTrackingStatus = (insightId: number, currentRole: string): ThunkAction<any, RootState, unknown, Action<string>> => dispatch => {
    return new Promise<void>((resolve, reject) => {
        axios.get(`${OPPORTUNITIES_API_PATHS.opportunities}/${insightId}/action-tracking?current_role=${currentRole}`).then((response) => {
            resolve(response.data);
        }).catch(() => reject());
    });
};

export const postActionTrackingData = (data: FormData | string | Blob | File | IUserActionRequestModel): ThunkAction<any, RootState, unknown, Action<string>> => dispatch => {
    return new Promise<void>((resolve, reject) => {
        axios.post(`${OPPORTUNITIES_API_PATHS.saveTracking}`, data,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }        
        }).then((response) => {
            resolve(response.data);
        }).catch(() => reject());
    });
};

export const updateUserAccessData = (data: IUserAccessDataModel[]) => {
    return new Promise<boolean>((resolve, reject) => {
        axios.post(`${OPPORTUNITIES_API_PATHS.opportunities}/user-update`, data).then((response: any) => {
            resolve(response);
        }).catch((e) => reject(e?.response?.data));
    });
}